import { render, staticRenderFns } from "./FooterBackToTop.vue?vue&type=template&id=254c3890"
import script from "./FooterBackToTop.vue?vue&type=script&lang=js"
export * from "./FooterBackToTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports